import addError from '../../../utils/error.jsx';

export function request(id, accountId, status) {
    return {
        type: 'BETS_PARK_BET_REQUEST',
        accountId,
        status,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'BETS_PARK_BET_ERROR',
        errors,
        id
    };
}

export function finish(id, data) {
    return {
        type: 'BETS_PARK_BET_FINISH',
        data,
        id
    };
}
